import { Link } from 'react-router-dom';

export default function ArticleFooter() {
  return (
    <footer className="w-full bg-accent-600 text-background-50">
      <div className="px-6 md:px-16 lg:px-28 py-14 md:py-16 max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="text-[11px] tracking-[0.25em] uppercase font-mono text-background-50/70">Prabhaw Insights</span>
            <h2 className="mt-3 text-3xl md:text-4xl leading-tight font-semibold tracking-tight">
              Research that informs real decisions.
            </h2>
          </div>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50 text-primary-700 text-sm font-medium hover:bg-background-100 transition cursor-pointer whitespace-nowrap"
          >
            Work With Us
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="mt-10 pt-8 border-t border-background-50/20 flex flex-col sm:flex-row items-center justify-between gap-4 text-[12px] tracking-[0.15em] uppercase font-mono text-background-50/70">
          <span className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-deva text-[18px] leading-none">प्रभाव</span> Prabhaw
          </span>
          <span className="whitespace-nowrap">© {new Date().getFullYear()} Prabhaw. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}